<template>
<div data-module="matter-article-header">
  <div class="module-layout">
    <div class="image-background"
      :style="bgImageStyles"
      ref="headerHeroImage"
    />
  </div>
</div>
</template>

<script>
// Lib
import Vue from 'vue';

// Utils
import { getResponsiveUrl } from '@/utils/image-utils';

import WorkMixin from '@/modules/work/WorkMixin';

export default {

  name: 'article-header',

  props: ['data'],

  mixins: [WorkMixin],

  data() {
    return {
      imageContentWidth: 0,
    };
  },

  computed: {

    bgImageStyles() {
      const { imageContentWidth } = this;
      const { imageSrc: src, hAlign: hA, vAlign: vA } = this.data;

      // add defaults
      const hAlign = hA || 'center';
      const vAlign = vA || 'center';

      const rUrl = getResponsiveUrl(src, imageContentWidth);
      return {
        backgroundImage: `url(${rUrl})`,
        backgroundPosition: `${hAlign} ${vAlign}`,
      };
    },

  },

  methods: {

    measureLayout() {
      this.imageContentWidth = this.getImageContentWidth();
    },

    getImageContentWidth() {
      const el = this.$refs.headerHeroImage;
      return (el) ? el.clientWidth : 0;
    },

  },

  watch: {

    currentWidth(/* newVal, oldVal */) {
      Vue.nextTick(() => {
        this.measureLayout();
      });
    },

  },

  mounted() {
    this.measureLayout();
  },
};
</script>


<style lang="scss" scoped>
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_grid.scss';
@import '~@/styles/_typography.scss';

$layout--percentage: $layout--max-content-width-ng / $layout--optimal-desktop * 100vw;

[data-module="matter-article-header"] {
  width: 100%;

  // media query props
  margin-top: rem($height--nav-bar-mobile * 1px); // adjust for nav bar
  margin-bottom: rem(42px);

  @include ngMq($nbp--tablet, up) {
    margin-top: rem(($height--nav-bar-mobile + $grid-padding-tablet) * 1px);
    margin-bottom: rem(54px);
  }

  @include ngMq($nbp--desktop, up) {
    margin-top: rem($height--nav-bar-desktop * 1px);
    margin-bottom: rem(34px);
  }

  .module-layout {
    // media query props
    @include ngGrid('mobile');

    @include ngMq($nbp--tablet, up) {
      @include ngGrid('tablet');
    }

    @include ngMq($nbp--desktop, up) {
      @include ngGrid('desktop');
    }

    // media query props
    .image-background {
      width: 100%;

      overflow: hidden;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;

      // media query props
      // grid-column: 1 / -1;
      grid-row: 1;
      width: 100vw;
      margin-left: rem($grid-padding-mobile * -1px); // pull to left, column
      padding-bottom: $dimension-1-1;

      @include ngMq($nbp--tablet, up) {
        grid-column: 1 / -1;
        width: 100%;
        margin-left: 0;
        padding-bottom: $dimension-16-9;
      }

      @include ngMq($nbp--desktop, up) {
        width: 100%;
        margin-left: 0;
        padding-bottom: $dimension-21-9;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/matter-article/ArticleHeader.vue